import { addDays, type ISODate } from "@/engine/date";

export type DatePresetId = "today" | "tomorrow" | "nextWeek" | "twoWeeks";

export interface DatePreset {
  id: DatePresetId;
  label: string;
  iso: ISODate;
}

/** 다음 주 월요일. 오늘이 월요일이면 7일 뒤다. */
export function nextWeekStart(today: ISODate): ISODate {
  const dow = (new Date(`${today}T00:00:00Z`).getUTCDay() + 6) % 7;
  return addDays(today, 7 - dow);
}

/** 달력 위의 바로가기. 값은 오늘 기준의 날짜다. */
export function datePresets(today: ISODate): DatePreset[] {
  return [
    { id: "today", label: "오늘", iso: today },
    { id: "tomorrow", label: "내일", iso: addDays(today, 1) },
    { id: "nextWeek", label: "다음 주", iso: nextWeekStart(today) },
    { id: "twoWeeks", label: "2주 뒤", iso: addDays(today, 14) },
  ];
}

export function presetInRange(iso: ISODate, min?: ISODate, max?: ISODate): boolean {
  if (min && iso < min) return false;
  if (max && iso > max) return false;
  return true;
}
